module.exports = __webpack_public_path__ + "_/sitemap.xml";